<template>
  <div class="index_content">
    <div class="f-row">
      <Breadcrumb separator=">" class="breadcrumb_zdy">
        当前位置:
        <BreadcrumbItem>数据</BreadcrumbItem>
        <BreadcrumbItem :to="{name: 'NoticeList'}">公告库列表页</BreadcrumbItem>
        <BreadcrumbItem>{{detail.title}}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div class="notice-index">
      <div class="notice-content">
        <div class="notice-info">
          <i class="iconfont">&#xe654;</i>
          <p>数据来自第三方网站，如需对数据纠错或其他需求咨询，随时联系我们，客服咨询：17338335471</p>
        </div>
        <p class="title">{{detail.title}}</p>
        <a class="pdf-a" :href="detail.pdf_url" target="_blank">查看PDF原文</a>
        <div class="text-part" v-html="detail.lcontent"></div>
      </div>
      <Spin fix v-if="spinShow">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
    </div>
  </div>
</template>

<script>
import { noticeDetail } from '../../service'
export default {
  data() {
    return {
      spinShow: true,
      detail: ''
    }
  },
  methods: {
    async getDetail() {
      let res = await noticeDetail({
        id: this.$route.params.id
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'detail', res.res[0])
      } else {
        this.$Message.error(res.message)
      }
      this.spinShow = false
    }
  },
  created() {
    this.getDetail()
  }
}
</script>

<style scoped lang="stylus">
@import '~styles/common.stylus'
@import '~styles/collect_share.stylus'
.index_content
  padding 16px 0 20px
  .notice-index
    width 1000px
    margin 20px auto
    position relative
    .notice-content
      position relative
      margin-top 16px
      commonBgColor(#1f2330, #FFFFFF)
      padding 30px 80px
      .notice-info
        margin-bottom 34px
        padding 14px 18px
        font-size 12px
        line-height 18px
        display flex
        align-items center
        commonBgColor(#113056, #F2FAFF)
        commonColor(#E9E9EB ,#666666)
        i
          commonColor(#57A3F3 ,#188DED)
          font-size 20px
          margin-right 12px
      .title
        width 700px
        font-size 28px
        line-height 40px
        margin -4px auto
        text-align center
        commonColor(#E9E9EB, #333333)
        font-weight 600
        font-weight bold
      .pdf-a
        display block
        text-align right
        color #FA7A50
        font-size 12px
        margin-top 8px
        &:hover
          color #fc9c7c
      .text-part
        font-size 16px
        commonColor(#E9E9EB, #333333)
        line-height 28px
        margin-top 22px
        >>>.detail-body
          padding 0 !important
</style>
